import { useTranslation } from "react-i18next";
import { Chapter } from "../components/Chapter";
import { Reveal, MaskedLine } from "../lib/motion";
import { usePageSeo } from "../lib/i18nContext";

const LegalLayout = ({ eyebrow, title, children, testid }) => (
  <main className="pt-nav">
    <section className="bg-white border-b border-ice">
      <div className="max-w-[1240px] mx-auto px-6 md:px-12 xl:px-16 py-16 md:py-24">
        <p className="font-mono text-xs md:text-[13px] font-medium tracking-[0.18em] uppercase text-pine mb-8">{eyebrow}</p>
        <h1 className="font-display font-semibold text-ink text-[36px] md:text-[44px] tracking-tight leading-[1.12]" data-testid={testid}>
          <MaskedLine delay={0.1}>{title}</MaskedLine>
        </h1>
      </div>
    </section>
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[820px] mx-auto px-6 md:px-12 space-y-12">{children}</div>
    </section>
  </main>
);

const Block = ({ index, title, children }) => (
  <Reveal>
    <div>
      <Chapter index={index} label={title} />
      <div className="mt-5 text-slate leading-relaxed space-y-4">{children}</div>
    </div>
  </Reveal>
);

const LegalPage = ({ pageKey, testid }) => {
  usePageSeo(pageKey);
  const { t } = useTranslation();
  const blocks = t(`legal.${pageKey}.blocks`, { returnObjects: true });
  return (
    <LegalLayout eyebrow={t("legal.eyebrow")} title={t(`legal.${pageKey}.title`)} testid={testid}>
      {blocks.map((b, i) => (
        <Block key={b.title} index={`0${i + 1}`} title={b.title}>
          {b.paragraphs.map((p) => (
            <p key={p.slice(0, 40)}>{p}</p>
          ))}
        </Block>
      ))}
    </LegalLayout>
  );
};

export const Privacy = () => <LegalPage pageKey="privacy" testid="privacy-headline" />;
export const Terms = () => <LegalPage pageKey="terms" testid="terms-headline" />;
